import { jsx as _jsx } from "react/jsx-runtime";
import { CashItemRow, MembershipItemRow, PackageItemRow } from "../Item/OrderItemRow";
import SubscriptionItemRow from "../Item/SubscriptionItemRow";
import { calculateSavedPoint } from "../utils/payUtils";
import PodOrderSection from "./PodOrderSection";
import SeparateOrderSection from "./SeparateOrderSection";
const ORDER_SECTION_CONFIG = {
    pod: {
        component: PodOrderSection,
        props: (paymentData)=>({
                orderType: "pod",
                podOrderData: paymentData
            })
    },
    separate: {
        component: SeparateOrderSection,
        props: (_data, context)=>{
            return {
                orderItems: (context === null || context === void 0 ? void 0 : context.orderItems) || [],
                dropDown: (context === null || context === void 0 ? void 0 : context.dropDown) || false,
                appliedMaxCoupon: (context === null || context === void 0 ? void 0 : context.appliedMaxCoupon) || false,
                applyCoupon: (context === null || context === void 0 ? void 0 : context.applyCoupon) || (()=>{}),
                userCoupons: (context === null || context === void 0 ? void 0 : context.userCoupons) || [],
                hasCoupon: (context === null || context === void 0 ? void 0 : context.hasCoupon) || false,
                checkAvailableCouponList: (context === null || context === void 0 ? void 0 : context.checkAvailableCouponList) || (()=>[]),
                handleDropDown: (context === null || context === void 0 ? void 0 : context.handleDropDown) || (()=>{})
            };
        }
    },
    delivery: {
        component: SeparateOrderSection,
        props: (_data, context)=>{
            return {
                orderItems: (context === null || context === void 0 ? void 0 : context.orderItems) || [],
                dropDown: (context === null || context === void 0 ? void 0 : context.dropDown) || false,
                appliedMaxCoupon: (context === null || context === void 0 ? void 0 : context.appliedMaxCoupon) || false,
                applyCoupon: (context === null || context === void 0 ? void 0 : context.applyCoupon) || (()=>{}),
                userCoupons: (context === null || context === void 0 ? void 0 : context.userCoupons) || [],
                hasCoupon: (context === null || context === void 0 ? void 0 : context.hasCoupon) || false,
                checkAvailableCouponList: (context === null || context === void 0 ? void 0 : context.checkAvailableCouponList) || (()=>[]),
                handleDropDown: (context === null || context === void 0 ? void 0 : context.handleDropDown) || (()=>{})
            };
        }
    },
    pass: {
        component: MembershipItemRow,
        props: (paymentData)=>({
                data: paymentData
            })
    },
    package: {
        component: PackageItemRow,
        props: (paymentData)=>({
                data: paymentData
            })
    },
    upgrade: {
        component: SeparateOrderSection,
        props: (_data, context)=>{
            return {
                orderItems: (context === null || context === void 0 ? void 0 : context.orderItems) || [],
                dropDown: (context === null || context === void 0 ? void 0 : context.dropDown) || false,
                appliedMaxCoupon: (context === null || context === void 0 ? void 0 : context.appliedMaxCoupon) || false,
                applyCoupon: (context === null || context === void 0 ? void 0 : context.applyCoupon) || (()=>{}),
                userCoupons: (context === null || context === void 0 ? void 0 : context.userCoupons) || [],
                hasCoupon: (context === null || context === void 0 ? void 0 : context.hasCoupon) || false,
                checkAvailableCouponList: (context === null || context === void 0 ? void 0 : context.checkAvailableCouponList) || (()=>[]),
                handleDropDown: (context === null || context === void 0 ? void 0 : context.handleDropDown) || (()=>{}),
                isUpgrade: true
            };
        }
    },
    cash: {
        component: CashItemRow,
        props: (paymentData)=>{
            var _cashData_products;
            const cashData = paymentData;
            const cashProduct = (_cashData_products = cashData.products) === null || _cashData_products === void 0 ? void 0 : _cashData_products[0];
            const savePoint = cashProduct ? calculateSavedPoint({
                bonusPointType: cashProduct.bonusPointType,
                bonusPointValue: cashProduct.bonusPointValue,
                price: cashProduct.price
            }) : null;
            return {
                data: cashData,
                savePoint
            };
        }
    },
    subscription: {
        component: SubscriptionItemRow,
        props: (paymentData)=>({
                data: paymentData
            })
    }
};
const OrderSection = (param)=>{
    let { orderType , paymentData , context  } = param;
    const config = ORDER_SECTION_CONFIG[orderType];
    if (!config) return null;
    const Component = config.component;
    const props = config.props(paymentData, context);
    return /*#__PURE__*/ _jsx(Component, {
        ...props
    });
};
export default OrderSection;
